import React from 'react'
import { Link } from 'react-router'
import { getEnvColor, getEnvName, Mtds, TestTubeIcon } from 'prove-common'

type AppLogoProps = {
  hidden?: boolean
}

export const AppLogo = ({ hidden }: AppLogoProps) => {
  const envName = getEnvName()
  const envColor = getEnvColor(envName)
  return (
    <Mtds.Logo
      as={Link}
      data-env={envName}
      data-color={envColor}
      hidden={hidden}
      to='/samples'
    >
      <TestTubeIcon weight='fill' /> Prøvelab
    </Mtds.Logo>
  )
}
